<template>
  <div v-if="hasDoctor" class="assigned-doctor-card">
    <div class="titleProfileSection">
      <v-icon small color="#4597DF">mdi-circle</v-icon>
      مشاور شما
    </div>

    <div class="doctor-card mt-4">
      <div class="text-center">
        <v-avatar size="90" color="#e8f5f1">
          <v-img v-if="doctor.avatar" :src="doctor.avatar" :alt="doctor.full_name" />
          <v-icon v-else color="#3CBE8B" size="40">mdi-account</v-icon>
        </v-avatar>
      </div>

      <div class="doctor-name text-center mt-3">
        {{ doctor.full_name }}
      </div>

      <div class="doctor-actions text-center mt-2">
        <v-btn
            v-if="doctor.resume_link"
            text
            x-small
            color="#3CBE8B"
            :href="doctor.resume_link"
            target="_blank"
        >
          نمایش رزومه
        </v-btn>
        <v-btn
            v-if="doctor.skype_link"
            small
            outlined
            color="primary"
            class="mt-2"
            :href="doctor.skype_link"
            target="_blank"
            block
        >
          لینک اسکایپ مشاور
          <v-icon small class="mx-1">mdi-skype</v-icon>
        </v-btn>
      </div>

      <div v-if="doctor.package" class="package-section mt-4">
        <v-divider class="mb-3" />
        <div class="package-title">بسته فعال</div>
        <div class="package-name mt-1">
          {{ doctor.package.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'AssignedDoctorCard',
  computed: {
    ...mapGetters({
      profile: 'getProfile',
    }),
    doctor() {
      return this.profile?.assignedDoctor
    },
    hasDoctor() {
      return this.doctor && !Array.isArray(this.doctor)
    },
  },
}
</script>

<style scoped>
.doctor-card {
  width: 100%;
  background: white;
  border-radius: 18px;
  padding: 20px;
  border: solid 1px #d1dcff;
}

.doctor-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.package-title {
  font-size: 13px;
  color: #959595;
}

.package-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
</style>
